import { render, staticRenderFns } from "./yhdista-lainat.vue?vue&type=template&id=b03c090a&"
import script from "./yhdista-lainat.vue?vue&type=script&lang=js&"
export * from "./yhdista-lainat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports